import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Fade,
} from "@mui/material";

// Fade animation
const TransitionFade = React.forwardRef(function Transition(props, ref) {
    return <Fade ref={ref} {...props} />;
});

const CommonDialog = ({
    open,
    size,
    content,
    title,
    actionButtons,
    animationDuration = 300, // Duration in ms
    onClose,
    padding,
    background
}) => {
    return (
        <Dialog
            fullWidth
            maxWidth={size}
            open={open}
            onClose={onClose}
            TransitionComponent={TransitionFade}
            TransitionProps={{
                timeout: animationDuration,
                // Add easing for smoother animation
                easing: { enter: "cubic-bezier(0.175, 0.885, 0.32, 1.275)", exit: "ease-in" }
            }}
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    minWidth: 300,
                    transformOrigin: "center center",
                    boxShadow: (theme) => `0 20px 60px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.15)'}`,
                    background: background
                }
            }}
            // Add backdrop animation
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                        backdropFilter: 'blur(2px)',
                        transition: `opacity ${animationDuration}ms ease-in-out`
                    }
                }
            }}
        >
            <DialogTitle
                sx={{
                    fontSize: '1.25rem',
                    fontWeight: 600,
                    pb: 0,
                    // Optional: Add subtle animation to title
                    animation: open ? `fadeIn 0.3s ease 0.1s both` : 'none',
                    '@keyframes fadeIn': {
                        from: { opacity: 0, transform: 'translateY(-10px)' },
                        to: { opacity: 1, transform: 'translateY(0)' }
                    },
                    p: padding
                }}
            >
                {title}
            </DialogTitle>
            <DialogContent
                sx={{
                    pb: 0,
                    animation: open ? `fadeIn 0.3s ease 0.2s both` : 'none',
                    '@keyframes fadeIn': {
                        from: { opacity: 0, transform: 'translateY(5px)' },
                        to: { opacity: 1, transform: 'translateY(0)' }
                    }
                }}
            >
                {content}
            </DialogContent>
            <DialogActions
                sx={{
                    px: 3,
                    pb: 2,
                    animation: open ? `fadeIn 0.3s ease 0.3s both` : 'none',
                    '@keyframes fadeIn': {
                        from: { opacity: 0, transform: 'translateY(5px)' },
                        to: { opacity: 1, transform: 'translateY(0)' }
                    }
                }}
            >
                {actionButtons}
            </DialogActions>
        </Dialog>
    )
}

export default CommonDialog;